// extracted by mini-css-extract-plugin
module.exports = {"outer":"Logo-module--outer--2lO6_","svg":"Logo-module--svg--jsruo"};